import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPosts } from "state";
import api from 'state/axios';
import PostWidget from "./PostWidget";


const PostsWidget = ({ userId, isProfile = false }) => {  
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.posts);  

  
  useEffect(() => {    
    const getPosts = async () => {
      const response = await api.get('/posts');
      const data = response.data;

      if (Array.isArray(data)) {
        dispatch(setPosts({ posts: data }));
      } else {
        dispatch(setPosts({ posts: [] })); 
      }
    };

    const getUserPosts = async () => {
      const response = await api.get(`/posts/${userId}/posts`);
      const data = response.data;

      if (Array.isArray(data)) {
        dispatch(setPosts({ posts: data }));
      } else {
        dispatch(setPosts({ posts: [] })); 
      }
    };
    
    if (isProfile) {
      getUserPosts();
    } else {
      getPosts();
    }
  }, [dispatch, userId, isProfile]); 


  return (
    <Fragment>
      {posts && posts.map(
        ({
          _id,
          userId,
          firstName,
          lastName,
          description,
          location,
          picturePath,
          userPicturePath,
          likes,
          comments,
          createdAt,
        }) => (
          <PostWidget
            key={_id}
            postId={_id}
            postUserId={userId}
            name={`${firstName} ${lastName}`}
            description={description}
            location={location}
            picturePath={picturePath}
            userPicturePath={userPicturePath}
            likes={likes}
            comments={comments}
            createdAt={createdAt}
          />
        )
      )}
    </Fragment>
  );
};

export default PostsWidget;
